var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592,
    y: 312,
    width: 29,
    height: 29
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8)",
    transform: "translate(-592 -312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606.5 330.125C604.506 330.125 602.875 328.494 602.875 326.5 602.875 324.506 604.506 322.875 606.5 322.875 608.494 322.875 610.125 324.506 610.125 326.5 610.125 328.494 608.494 330.125 606.5 330.125ZM614.656 324.234C614.475 323.57 614.203 322.935 613.871 322.361L614.626 320.096 612.904 318.374 610.639 319.129C610.034 318.797 609.4 318.525 608.735 318.344L607.708 316.229 605.292 316.229 604.234 318.344C603.57 318.525 602.935 318.797 602.361 319.129L600.096 318.374 598.374 320.096 599.129 322.361C598.797 322.966 598.525 323.6 598.344 324.265L596.229 325.292 596.229 327.708 598.344 328.766C598.525 329.43 598.797 330.065 599.129 330.639L598.374 332.904 600.096 334.626 602.361 333.871C602.966 334.203 603.6 334.475 604.265 334.656L605.322 336.771 607.739 336.771 608.796 334.656C609.46 334.475 610.095 334.203 610.669 333.871L612.934 334.626 614.656 332.904 613.901 330.639C614.233 330.034 614.505 329.4 614.686 328.735L616.801 327.678 616.801 325.261 614.656 324.234Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavGear);
export default __webpack_public_path__ + "static/media/nav-gear.ac89a046007868c92e9006d4da97f966.svg";
export { ForwardRef as ReactComponent };